import { varDomain } from "../modules/common/defaults";

export const changeShop = (domain) => {
  varDomain(domain);
  window.location.href = window.location.origin;
};
